module.exports = __webpack_public_path__ + "static/media/earning_without_instruction.eaa5a2f4.svg";